<ion-row class="p-10">
  <ion-col size>
    <div class="form-title fs-20 font_bold text-primary">Asset Management</div>
  </ion-col>
  <ion-col size="auto">
    <span
    class="material-icons fs-22 btn-reset mr-10"
    style="cursor:pointer; vertical-align:middle;"
    [class.clicked]="isClicked"
    (click)="resetGrid()"
    (animationend)="isClicked = false">
    refresh
  </span>
  
  <!-- Close Icon -->
  <img
  [mat-dialog-close]
  src="././assets/icon/close_icon.png"
  class="close-icon cp ml-5"
  alt="close"
  style="width: 22px; vertical-align:middle;" />
</ion-col>
</ion-row>

<mat-dialog-content>
  <!-- <div class="form-container p-20"> -->
    <!-- <div class="cardLayout shadow-md rounded-xl bg-white"> -->
      
      <!-- ===== Header Section ===== -->
      <!-- <ion-row class="align-center justify-between header-bar mb-20"> -->
        <!-- Left: Title -->
        <!-- <ion-col size="8" class="ion-text-start"> -->
        <!-- </ion-col> -->
        
        <!-- Right: Icons -->
        <!-- <ion-col size="4" class="ion-text-end"> -->
          <!-- Refresh Icon -->
          <!-- <span
          class="material-icons fs-22 btn-reset mr-10"
          style="cursor:pointer; vertical-align:middle;"
          [class.clicked]="isClicked"
          (click)="resetGrid()"
          (animationend)="isClicked = false">
          refresh
        </span> -->
        
        <!-- Close Icon -->
        <!-- <img
        [mat-dialog-close]
        src="././assets/icon/close_icon.png"
        class="close-icon cp ml-5"
        alt="close"
        style="width: 22px; vertical-align:middle;" />
      </ion-col> -->
    <!-- </ion-row> -->
    
    <!-- ===== Filters Section ===== -->
    <ion-row class="phi-flex-wrap phi-gap-16 p-10 bg-light rounded-lg border mb-15">
      
      <!-- Asset -->
      <ion-col size="12" size-md="4">
        <div class="font_semibold fs-15 mb-6">Asset <span class="red-cl">*</span></div>
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <mat-select
          [(ngModel)]="selectedAsset"
          placeholder="Select Asset"
          (selectionChange)="onAssetChange1($event.value)">
          <mat-option *ngFor="let asset of AllAssetListingData" [value]="asset.assetName">
            {{ asset.assetName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>
    
    <!-- Band -->
    <ion-col size="12" size-md="4">
      <div class="font_semibold fs-15 mb-6">Band <span class="red-cl">*</span></div>
      <ng-multiselect-dropdown
      class="w-100"
      [placeholder]="'Select Band'"
      [settings]="dropdownSettingsForBand"
      [data]="dropDownForband"
      [(ngModel)]="selectedBand"
      (onSelect)="onSelectBand($event)"
      (onDeSelect)="onDeselectBand($event)"
      (onSelectAll)="selectAllBand($event)"
      (onDeSelectAll)="onDeSelectAllBand($event)">
    </ng-multiselect-dropdown>
  </ion-col>
  
  <!-- Employee -->
  <ion-col size="12" size-md="4">
    <div class="font_semibold fs-15 mb-6">Employee <span class="red-cl">*</span></div>
    <ng-multiselect-dropdown
    [placeholder]="'Select Employee'"
    class="w-100"
    [settings]="dropdownSettingsForEmployee"
    [data]="dropDownForEmployee"
    [(ngModel)]="selectedEmployee"
    (onSelect)="onSelectSingleEmp($event)"
    (onDeSelect)="onDeSelectSingleEmp($event)"
    (onSelectAll)="selectAllEmp($event)"
    (onDeSelectAll)="onDeSelectAllEmpForReport($event)">
  </ng-multiselect-dropdown>
</ion-col>
</ion-row>

<!-- ===== AG Grid Section ===== -->
<div class="ag-grid-wrapper">
  <ag-grid-angular
  class="ag-theme-quartz custom-ag-grid improved-grid"
  [rowData]="allocatedAssetsList"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [defaultColDef]="defaultColDef"
  (gridReady)="onGridReady($event)"
  (rowClicked)="onRowClicked($event)"
  (cellClicked)="onCelledClicked($event)"
  (cellValueChanged)="onCellValueChanged($event)"
  [pagination]="pagination"
  [paginationPageSize]="paginationPageSize"
  [paginationPageSizeSelector]="paginationPageSizeSelector"
  [detailRowAutoHeight]="detailRowAutoHeight"
  [localeText]="{ noRowsToShow: 'No Data Found' }">
</ag-grid-angular>
</div>

<!-- ===== Footer Buttons ===== -->
<ion-row>
  <ion-col size="12" class="text-right mt-20">
    <button
    type="button"
    class="add_btn fs-15 px-20 py-8 rounded-lg shadow-sm"
    [style.background-color]="buttonColorName"
    (click)="saveData()">
    Allocate Asset
  </button>
  
  <button
  class="back_btn fs-15 ml-10 px-20 py-8 rounded-lg border"
  (click)="cancelData()">
  Cancel
</button>
</ion-col>
</ion-row>

<!-- </div> -->
<!-- </div> -->
</mat-dialog-content>
